export const getLocationEventEmoji = (eventName: string) => {
  switch (eventName) {
    case 'birthday_cafe':
      return '/assets/icons/graphic-3d/3D.Birthday cake.png';
    case 'experience_space':
      return '/assets/icons/graphic-3d/3D.Exhibition.png';
    case 'billboard_ad':
      return '/assets/icons/graphic-3d/3D.Signboard.png';
    case 'landmark':
      return '/assets/icons/graphic-3d/3D.Place.png';
    case 'foodie_spot':
      return '/assets/icons/graphic-3d/3D.Restaurant.png';
  }
};

export const getContentTypeEmoji = (contentType: string) => {
  switch (contentType) {
    case 'official_content':
      return '/assets/icons/graphic-3d/3D.verfied.fill.png';
    case 'direct_sighting':
      return '/assets/icons/graphic-3d/3D.Eyes.png';
    case 'fan_content':
      return '/assets/icons/graphic-3d/3D.Sparkling heart.png';
    case 'live_broadcast':
      return '/assets/icons/graphic-3d/3D.Live.png';
  }
};

export const processedGoodsNames = (goodsNames: string[]) => {
  if (goodsNames.length < 2) {
    return goodsNames;
  }
  return `${goodsNames.slice(0, 2).join(', ')} 외 ${goodsNames.length - 2}개`;
};

export const getEventCompleteImage = (eventName: string) => {
  switch (eventName) {
    case 'birthday_cafe':
      return '/assets/icons/graphic-3d/3D.Birthday cake.png';
    case 'experience_space':
      return '/assets/icons/graphic-3d/3D.Exhibition.png';
    case 'billboard_ad':
      return '/assets/icons/graphic-3d/3D.Signboard.png';
    default:
      return '/assets/icons/graphic-3d/3D.Map.png';
  }
};